/* Algolia */
export const AlgoliaAppId = 'TJ1BNHU59E';
export const AlgoliaApiKey = '0e260e0027359bc81729c9a189ca2734';

/* Google */
export const GoogleApiKey = 'AIzaSyDUTtAiS0Wv0vQdaulP8iB_9qgIrlLXzt8';



// WEBPACK FOOTER //
// ./src/App_Data/ClesAPI.js